import { render, staticRenderFns } from "./ReferralCodeCreate.vue?vue&type=template&id=61aef1c6&"
import script from "./ReferralCodeCreate.vue?vue&type=script&lang=ts&"
export * from "./ReferralCodeCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralCodeCreate.vue?vue&type=style&index=0&id=61aef1c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports